module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/Home"
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/Feature"
    }
  }, [_vm._v(_vm._s(_vm.$t('features')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/Prices"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricing')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/Resource"
    }
  }, [_vm._v(_vm._s(_vm.$t('resources')))])], 1), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://openapi.craitapp.com",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('openapi')))])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/Contact"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('download')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('a', {
    attrs: {
      "href": "https://www.craitapp.com/login/index.html",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048844ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 256
// module chunks = 1